export const CREATE_RULE = 'table/rule/CREATE_RULE'
export const EDIT_RULE = 'table/rule/EDIT_RULE'
export const DELETE_RULE = 'table/rule/DELETE_RULE'
export const SET_RULE = 'table/rule/SET_RULE'
export const TOGGLE_LOADING = 'table/rule/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'table/rule/TOGGLE_SUCCESS'
